import { bookingInquiryApis } from '@apis/dashboard/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { BookingInquiryMemo } from '@models/BookingInquiry';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchBookingInquiryMemo = (d2d_no: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: BookingInquiryMemo) => {
      const response = await bookingInquiryApis.patch('/dashboard/booking-inquiry/{d2d_no}/memo/', {
        path: { d2d_no },
        body,
      });

      if (response[400]) {
        throw new FormError('PatchBookinfInquiryMemo', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/booking-inquiry/${d2d_no}/`]);
        queryClient.invalidateQueries([`/dashboard/booking-inquiry/${d2d_no}/memo/`]);
      },
    },
  );
};
